import { ChangeDetectorRef, Component, HostListener, Inject, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Observable, Subscription } from 'rxjs';

import { BannerMessage, ContextMenuConfiguration, ContextMenuItem, ContextMenuRequest, ErrorResponse, EshavaDialogRef, eshavaDialogData } from '../../models';
import { ContextMenuService, TranslationService } from '../../services';
import { BannerMessageLevel } from '../../enums';
import { errorMessageConstants } from '../../constants';
import { EshavaSingleDialogComponent } from '../eshava-single-dialog/eshava-single-dialog.component';
import { MessageBannerComponent } from '../message-banner/message-banner.component';
import { ComponentLoadingIndicatorComponent } from '../component-loading-indicator/component-loading-indicator.component';

@Component({
    selector: 'lib-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [EshavaSingleDialogComponent, MessageBannerComponent, ComponentLoadingIndicatorComponent]
})
export class ConfirmDialogComponent implements OnInit, OnDestroy {
  private _subscriptions: Subscription = new Subscription();

  public dialogTitle: string = '';
  public dialogMessage: string = '';
  public primaryButtonTitle: string = '';
  public secondaryButtonTitle: string = '';
  public showLoadingIndicator = true;
  public errorMessage: BannerMessage | undefined;

  constructor(
    @Inject(eshavaDialogData) private _templateData: {
      dialogTitle: string,
      dialogMessage: string,
      primaryButtonTitle: string,
      secondaryButtonTitle: string,
      confirm: () => Observable<BannerMessage>
    },
    private _dialogRef: EshavaDialogRef,
    private _cdr: ChangeDetectorRef,
    private _translationService: TranslationService
  ) {
    this.dialogTitle = this._templateData.dialogTitle;
    this.dialogMessage = this._templateData.dialogMessage;
    this.primaryButtonTitle = this._templateData.primaryButtonTitle;
    this.secondaryButtonTitle = this._templateData.secondaryButtonTitle;
  }

  public ngOnInit(): void {
    this.showLoadingIndicator = false;
  }

  public ngOnDestroy(): void {
    this._subscriptions.unsubscribe();
  }

  public ngAfterViewChecked(): void {
    this._cdr.detectChanges();
  }

  public closeDialog(reload: boolean = false): void {
    this._dialogRef.close(reload);
  }

  public confirm(): void {
    this.showLoadingIndicator = true;
    this._templateData.confirm().subscribe({
      next: errorMessage => {
        this.showLoadingIndicator = false;

        if (errorMessage) {
          this.errorMessage = errorMessage;

          return;
        }

        this.closeDialog(true);
      },
      error: (errorResponse: ErrorResponse) => {
        this.showLoadingIndicator = false;

        this.errorMessage = {
          level: errorResponse.status! >= 500 ? BannerMessageLevel.critical : BannerMessageLevel.error,
          title: this._translationService.translate(errorMessageConstants.UNEXPECTEDERROR, 'errors'),
          text1: errorResponse.error?.message ? this._translationService.translate(errorResponse.error?.message, 'errors') : ''
        };
        this.showLoadingIndicator = false;
      }
    });
  }
}
